import NavTopWorkbench from '../nav-main/src/v2/nav-top-workbench';

/* istanbul ignore next */
NavTopWorkbench.install = function(Vue) {
  Vue.component(NavTopWorkbench.name, NavTopWorkbench);
};

export default NavTopWorkbench;
